// Layer registry for the map visualization. A map config is
// { baseLayer, layers: [...] }; the first (and only fixed) layer is the
// basemap, and every overlay is a user-added layer with a type + options.
// Kept dependency-free so the defaults are unit-testable without rendering.

// Available overlay layer types. `groupable` layers (donuts, labels) cluster
// rows by a field into one marker per group; point layers (dots, pie, bar)
// plot one marker per result row.
export const LAYER_TYPES = [
  { type: 'dots', label: 'Dots', groupable: false },
  { type: 'pie', label: 'Pie', groupable: false },
  { type: 'bar', label: 'Bar', groupable: false },
  { type: 'donuts', label: 'Donuts', groupable: true },
  { type: 'labels', label: 'Labels', groupable: true }
];

export function layerLabel(type) {
  return (LAYER_TYPES.find((t) => t.type === type) || { label: type }).label;
}

// A fresh layer of the given type. `group` is the field used to cluster rows
// (null = one marker per row); point layers keep it null. `options` holds the
// type-specific customizations.
export function defaultLayer(type, id) {
  const layer = { id: id || newLayerId(), type, visible: true, group: null };
  switch (type) {
    case 'dots':
      layer.options = { color: '#2e7d32', size: 8 };
      break;
    case 'pie':
      layer.options = { valueField: null, palette: 'default', size: 1 };
      break;
    case 'bar':
      layer.options = { valueField: null, color: '#2e7d32', size: 1 };
      break;
    case 'donuts':
      layer.options = { columns: [], palette: 'default', size: 1 };
      break;
    case 'labels':
      layer.options = { field: null };
      break;
    default:
      layer.options = {};
  }
  return layer;
}

// Monotonic ids so React keys stay stable across re-renders. A timestamp
// suffix lets multiple maps on one page coexist.
let counter = 0;
export function newLayerId() {
  counter += 1;
  return `layer-${Date.now().toString(36)}-${counter}`;
}
